import { useLocation } from 'react-router-dom';
import React from 'react';

export function WithRouterWrapper(WrappedComponent) {
    
    return (props) => {
        const location = useLocation();
        const newProps = {
            ...props,
            location: location
        }
        return <WrappedComponent {...newProps} />
    };
}